import type { ColDef } from "ag-grid-community";
import i18n from "i18next";
import moment from "moment";
import k from "src/i18n/keys";
import { ReportNameCellRenderer, CreatedByCellRenderer } from "./cellRenderers";
import type { Report } from "src/types";

const formatTimestampSeconds = (seconds?: number): string => {
  if (!seconds) return "";
  return moment.unix(seconds).format(i18n.t(k.MMM_DD_YYYY_HH_MM_A));
};

export const getColumns = (): Array<ColDef<Report>> => [
  {
    headerName: i18n.t(k.REPORT_NAME),
    field: "title",
    flex: 8,
    minWidth: 400,
    cellRenderer: ReportNameCellRenderer,
    valueGetter: (params) => {
      if (!params.data) return "";
      return params.data.title || "";
    },
    getQuickFilterText: (params) => {
      if (!params.data) return "";
      return params.data.title || "";
    },
    sort: "asc",
    sortIndex: 0,
  },
  {
    headerName: i18n.t(k.CREATED_AT),
    field: "createdAt",
    flex: 1,
    minWidth: 230,
    valueGetter: (params) => {
      return formatTimestampSeconds(params.data?.createdAt?.seconds);
    },
  },
  {
    headerName: i18n.t(k.UPDATED_AT),
    field: "updatedAt",
    flex: 1,
    minWidth: 230,
    valueGetter: (params) => {
      return formatTimestampSeconds(params.data?.updatedAt?.seconds);
    },
  },
  {
    headerName: i18n.t(k.CREATED_BY1),
    field: "creator",
    flex: 1,
    minWidth: 230,
    cellRenderer: CreatedByCellRenderer,
    valueGetter: (params) => {
      if (!params.data?.creator) return "";
      return params.data.creator;
    },
    sortable: false,
  },
];
